import React, { PureComponent } from 'react';
import {
    ComposedChart, Line, Area, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
    Legend, ResponsiveContainer
} from 'recharts';

const data = [
    {
        name: '3 Months', lr: 0.88, rf: 0.70, nn: 0.87, average: 0.81,
    },
    {
        name: '6 Months', lr: 0.69, rf: 0.51, nn: 0.57, average: 0.59,
    },
    {
        name: '12 Months', lr: 0.34, rf: 0.43, nn: 0.60, average: 0.46,
    },
];


export default class DefaultRiskChart extends PureComponent {

    render() {
        return (
            <ResponsiveContainer width="100%" height={350}>
            <ComposedChart
                data={data}
                margin={{
                    top: 0, right: 0, bottom: 0, left: 0,
                }}
            >
                <CartesianGrid stroke="#f5f5f5" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="lr" barSize={20} fill="#505050" />
                <Bar dataKey="rf" barSize={20} fill="#808080" />
                <Bar dataKey="nn" barSize={20} fill="#A9A9A9" />
                <Line type="monotone" dataKey="average" stroke="#000000" strokeDasharray="5 3" />
            </ComposedChart>
            </ResponsiveContainer>
        );
    }
}
